import { render } from "./freeSvg.vue?vue&type=template&id=44a97c89&scoped=true"
import script from "./freeSvg.vue?vue&type=script&lang=js"
export * from "./freeSvg.vue?vue&type=script&lang=js"

import "./freeSvg.vue?vue&type=style&index=0&id=44a97c89&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a97c89"]])

export default __exports__